var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-mission"},[_c('h2',{class:{
      'text-h2': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-h2T': _vm.$mq === 'm',
      'text-h4': _vm.$mq === 's'
    }},[_vm._v("\n    Наша миссия\n  ")]),_c('h3',{class:{
      'text-h3': _vm.$mq === 'xl' || _vm.$mq === 'l' || _vm.$mq === 'm',
      'text-h5': _vm.$mq === 's'
    }},[_vm._v("\n    Тесное сотрудничество с клиентами является основой нашей деятельности\n  ")]),_c('p',{staticClass:"text-body2",class:{
      'text-body2': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-body4': _vm.$mq === 'm',
      'text-body6': _vm.$mq === 's'
    }},[_vm._v("\n    Компании - участники нефтяного рынка РФ все чаще сталкиваются\n    с уникальными проблемами. Опираясь на корпоративную культуру,\n    ресурсы, глубокое понимание рабочих процессов и на опыт в разработке и\n    внедрении инновационных технических решений, ООО “ЕРС” всегда\n    сможет предоставить своим заказчикам экономически выгодные,\n    технологические решения.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }